const channelKind = (channel)=>channel.type;
export const verb = (channel)=>channelKind(channel) === 'email' ? 'emailed' : 'texted';
export const ch = (channel)=>channelKind(channel) === 'email' ? 'email' : 'SMS';
export const contactFor = (channel)=>channel.type === 'email' ? channel.email.address : channel.sms.phoneNumber;
export const formatRecipient = (recipient, channel)=>"".concat(recipient.name, " (").concat(contactFor(channel), ")");
export const groupRecipients = (deliveries)=>Array.from(deliveries.reduce((acc, d)=>{
        const existing = acc.get(d.recipient.userId);
        const contact = contactFor(d.channel);
        if (existing) {
            if (!existing.contacts.includes(contact)) existing.contacts.push(contact);
            return acc;
        }
        acc.set(d.recipient.userId, {
            name: d.recipient.name,
            contacts: [
                contact
            ]
        });
        return acc;
    }, new Map()).values()).map((r)=>"".concat(r.name, " (").concat(r.contacts.join(', '), ")")).join(', ');
export const joinChannelVerbs = (deliveries)=>Array.from(new Set(deliveries.map((d)=>verb(d.channel)))).join(' + ');
export const joinChannelLabels = (deliveries)=>Array.from(new Set(deliveries.map((d)=>ch(d.channel)))).join(' + ');
export const isApprovalRequest = (channel)=>channel.type === 'email' && /^Action required:/i.test(channel.email.subject);
export const anyDeliveryIsApprovalRequest = (deliveries)=>deliveries.some((d)=>isApprovalRequest(d.channel));
